/* ce-nav-hover-intent — adds a dwell delay before desktop mega
   panels open. Custom cultureEDIT file (not part of Horizon 4.1.1).

   Horizon's header-menu opens submenus instantly on pointerenter
   (its HOVER_COMMIT_DELAY_MS only gates an internal event), so
   panels fly open when the cursor merely crosses the nav on its way
   down the page (client note 2026-07). This wraps the component's
   public activate/deactivate per instance: pointer-driven opens
   require ~120ms of dwell; keyboard focus stays instant.
   Loaded from sections/ce-header.liquid.

   FIXED 2026-10-05 — "sometimes the menu just doesn't open until I
   hover another item and come back":
   1. One shared timer, cancelled by ANY deactivate. Moving Apparel ->
      Underwear queued Underwear's open, then Apparel's pointerleave —
      which Horizon's safety box (the ::after that keeps a panel open
      while the pointer travels toward it) often delivers late, after
      the next item's pointerenter — cancelled it. The pointer rested
      on Underwear with nothing open, and pointerenter does not fire
      again until the pointer leaves and returns. A deactivate now only
      cancels a pending open for the SAME item.
   2. "Already wrapped" was marked with data-ce-intent, which Horizon's
      section hydration morphs away (seen missing on the live Store), so
      a re-run would wrap the wrapper. Now a WeakSet, and a header-menu
      added later (hydration replacing the node) gets wrapped too. */
(() => {
  const INTENT_DELAY_MS = 120;
  const wrapped = new WeakSet();

  const itemOf = (event) => {
    const target = event && event.target;
    return target && target.closest ? target.closest('.menu-list__list-item') : null;
  };

  const init = (el) => {
    if (wrapped.has(el) || typeof el.activate !== 'function') return;
    wrapped.add(el);

    const origActivate = el.activate;
    const origDeactivate = el.deactivate.bind(el);
    let timer;
    let pending = null;

    const cancel = () => {
      clearTimeout(timer);
      pending = null;
    };

    el.activate = (event) => {
      if (event instanceof FocusEvent) {
        cancel();
        origActivate(event);
        return;
      }
      const item = itemOf(event);
      if (item && item === pending) return;
      cancel();
      pending = item;
      timer = setTimeout(() => {
        pending = null;
        origActivate(event);
      }, INTENT_DELAY_MS);
    };

    el.deactivate = (event) => {
      const item = itemOf(event);
      if (pending && (!item || item === pending)) cancel();
      return origDeactivate(event);
    };
  };

  const boot = () => document.querySelectorAll('header-menu').forEach(init);

  customElements.whenDefined('header-menu').then(() => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    // Catch a header-menu that hydration swaps in after boot.
    const root = document.querySelector('header-component, #header-component') || document.body;
    new MutationObserver(boot).observe(root, { childList: true, subtree: true });
  });
})();
